import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { BaseUrl } from "../../../../BaseUrl";
import { toastError, toastSuccess } from "../../../../Toast/Toast";
import { appendVideoFormData } from "../../../../VideoFormData";

// insert / update
export const POST_M_WebinarVideoMaster_InsertAPI = createAsyncThunk(
    "POST_M_WebinarVideoMaster_Insert",
    async ({ data }) => {
        const {
            WebinarVideoID,
            TitleName,
            SubTitleName,
            Description,
            VideoList,
            M_UserID,
            token,
            handleIsPost,
            setloader,
            ScreenType,
            Video_PurchaseAmount
        } = data

        const isUpdate = ScreenType === "Update"
        const videoList = VideoList || []

        const myHeaders = new Headers()
        myHeaders.append("Accept", "application/json")
        if (token) {
            myHeaders.append("Authorization", "Bearer " + token)
        }

        // Body
        const formdata = new FormData()
        if (isUpdate) {
            formdata.append("WebinarVideoID", WebinarVideoID)
        }
        formdata.append("TitleName", TitleName)
        formdata.append("SubTitleName", SubTitleName)
        formdata.append("Description", Description)
        formdata.append("Video_PurchaseAmount", Video_PurchaseAmount)
        formdata.append("M_UserID", M_UserID)

        appendVideoFormData(formdata, videoList, isUpdate, "WebinarVideoDetailID")

        const method = isUpdate ? "PATCH" : "POST"
        const url = isUpdate
            ? BaseUrl + "/Master/M_WebinarVideoMaster_Update"
            : BaseUrl + "/Master/M_WebinarVideoMaster_Insert"

        try {
            const response = await fetch(url, {
                method: method,
                headers: myHeaders,
                body: formdata,
                redirect: "follow",
            })
            const result = await response.json()

            if (result.code >= 200 && result.code <= 300) {
                toastSuccess(result?.message)
                if (handleIsPost) handleIsPost(result.message)
            } else {
                toastError(result?.message)
            }
            if (setloader) setloader(false)
            return result
        } catch (error) {
            toastError("Something went wrong")
            if (setloader) setloader(false)
            throw error // makes the thunk go to `rejected`
        }
    }
)

const POST_M_WebinarVideoMaster_InsertSlice = createSlice({
    name: "POST_M_WebinarVideoMaster_Insert",
    initialState: {
        isPostLoading: false,
        PostData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(POST_M_WebinarVideoMaster_InsertAPI.pending, (state) => {
            state.isPostLoading = true
            state.isError = false
        })
        builder.addCase(POST_M_WebinarVideoMaster_InsertAPI.fulfilled, (state, action) => {
            state.isPostLoading = false
            state.isError = false
            state.PostData = action.payload
        })
        builder.addCase(POST_M_WebinarVideoMaster_InsertAPI.rejected, (state, action) => {
            console.log("Error", action.error?.message)
            state.isPostLoading = false
            state.isError = true
            state.PostData = null
        })
    },
})

export const POST_M_WebinarVideoMaster_InsertReducer = POST_M_WebinarVideoMaster_InsertSlice.reducer


// delete
export const M_WebinarVideoMaster_DeleteAPI = createAsyncThunk("M_WebinarVideoMaster_Delete", async ({ data }) => {
    const {
        WebinarVideoID,
        M_UserID,
        token,
        handleIsPost,
        setloader,
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Accept", "application/json");
    if (token) {
        myHeaders.append("Authorization", "Bearer " + token);
    }

    var formdata = new FormData();
    formdata.append("WebinarVideoID", WebinarVideoID);
    formdata.append("M_UserID", M_UserID);

    const requestOptions = {
        method: "DELETE",
        headers: myHeaders,
        body: formdata,
        redirect: "follow",
    };

    const url = `${BaseUrl}/Master/M_WebinarVideoMaster_Delete`

    return fetch(url, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300) {
                toastSuccess(result?.message)
                handleIsPost && handleIsPost(result.message)
            } else {
                toastError(result?.message)
            }
            setloader && setloader(false)
            return result
        })
        .catch((error) => {
            toastError("Something went wrong")
            setloader && setloader(false)
            throw error
        })
})

const M_WebinarVideoMaster_DeleteSlice = createSlice({
    name: "M_WebinarVideoMaster_Delete",
    initialState: {
        isDeleteLoading: false,
        DeleteData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(M_WebinarVideoMaster_DeleteAPI.pending, (state) => {
            state.isDeleteLoading = true;
            state.isError = false;
        });
        builder.addCase(M_WebinarVideoMaster_DeleteAPI.fulfilled, (state, action) => {
            state.isDeleteLoading = false;
            state.isError = false;
            state.DeleteData = action.payload;
        });
        builder.addCase(M_WebinarVideoMaster_DeleteAPI.rejected, (state, action) => {
            console.log("Error", action.error?.message);
            state.isDeleteLoading = false;
            state.isError = true;
            state.DeleteData = null;
        });
    },
})

export const M_WebinarVideoMaster_DeleteReducer = M_WebinarVideoMaster_DeleteSlice.reducer


// get data
export const GET_M_WebinarVideoMaster_SelectAPI = createAsyncThunk("GET_M_WebinarVideoMaster_Select", async ({ data }) => {
    const {
        WebinarVideoID,
        SearchTerm,
        Flag,
        M_UserID,
        Language,
        FromTop,
        ToTop,
        token,
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Accept", "application/json");
    if (token) {
        myHeaders.append("Authorization", "Bearer " + token);
    }

    var requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
    };

    const url = `${BaseUrl}/Master/Get_M_WebinarVideoMaster_Select?WebinarVideoID=${WebinarVideoID}&SearchTerm=${encodeURIComponent(SearchTerm ?? "")}&Flag=${Flag}&M_UserID=${M_UserID}&Language=${Language}&FromTop=${FromTop}&ToTop=${ToTop}`

    return fetch(url, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data && result?.data?.table) {
                return result.data.table
            } else {
                return result
            }
        })
})

const GET_M_WebinarVideoMaster_SelectSlice = createSlice({
    name: "GET_M_WebinarVideoMaster_Select",
    initialState: {
        isLoading: false,
        TableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(GET_M_WebinarVideoMaster_SelectAPI.pending, (state) => {
            state.isLoading = true;
            state.isError = false;
            state.TableData = [];
        });
        builder.addCase(GET_M_WebinarVideoMaster_SelectAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.isError = false;
            state.TableData = action.payload;
        });
        builder.addCase(GET_M_WebinarVideoMaster_SelectAPI.rejected, (state, action) => {
            console.log("Error", action.error?.message);
            state.isLoading = false;
            state.isError = true;
            state.TableData = null;
        });
    },
})

export const GET_M_WebinarVideoMaster_SelectReducer = GET_M_WebinarVideoMaster_SelectSlice.reducer